import { render, staticRenderFns } from "./DataPermissionNotice.vue?vue&type=template&id=7f77cfc6"
import script from "./DataPermissionNotice.vue?vue&type=script&lang=ts"
export * from "./DataPermissionNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports